(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exa-link-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.shopify-section')?.querySelector('[data-exa-link-hub]')
      || document.querySelector('[data-exa-link-hub]');
    if (!root || root.dataset.ready === 'true') return;

    root.dataset.ready = 'true';
    document.documentElement.classList.add('exa-link-hub-active');

    const status = root.querySelector('[data-share-status]');
    let statusTimer;

    const showStatus = (message) => {
      if (!status) return;
      status.textContent = message;
      status.classList.add('is-visible');
      window.clearTimeout(statusTimer);
      statusTimer = window.setTimeout(() => status.classList.remove('is-visible'), 1800);
    };

    root.querySelectorAll('.exa-link-hub__share').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.dataset.shareUrl || window.location.href;
        const title = button.dataset.shareTitle || document.title;
        try {
          if (navigator.share) {
            await navigator.share({ title, url });
          } else {
            await navigator.clipboard.writeText(url);
            showStatus(root.dataset.shareCopied);
          }
        } catch (error) {
          if (error?.name !== 'AbortError') showStatus(root.dataset.shareFailed);
        }
      });
    });

    const carousel = root.querySelector('[data-carousel]');
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');

    if (carousel && previous && next) {
      const updateButtons = () => {
        const max = carousel.scrollWidth - carousel.clientWidth;
        previous.disabled = carousel.scrollLeft <= 2;
        next.disabled = carousel.scrollLeft >= max - 2;
      };

      const advance = (direction) => {
        const card = carousel.querySelector('.exa-link-hub__archive-card');
        const gap = 14;
        const distance = card ? card.getBoundingClientRect().width + gap : carousel.clientWidth * .45;
        carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => advance(-1));
      next.addEventListener('click', () => advance(1));
      carousel.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exa-shop-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      document.documentElement.classList.add('exa-shop-hub-active');

      const input = root.querySelector('[data-shop-search]');
      const cards = [...root.querySelectorAll('[data-collection-card]')];
      const empty = root.querySelector('[data-shop-empty]');
      const results = root.querySelector('[data-shop-results]');

      const applyFilter = () => {
        const query = normalize(input?.value || '');
        let visible = 0;

        cards.forEach((card) => {
          const matches = !query || normalize(card.dataset.searchTerms || '').includes(query);
          card.hidden = !matches;
          if (matches) visible += 1;
        });

        if (empty) empty.hidden = visible !== 0;
        if (results) {
          if (visible === 0) results.textContent = root.dataset.resultsEmpty;
          else if (visible === 1) results.textContent = root.dataset.resultsOne;
          else results.textContent = `${visible} ${root.dataset.resultsOther}`;
        }
      };

      input?.addEventListener('input', () => {
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(applyFilter);
        } else {
          applyFilter();
        }
      });

      root.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
        const wrap = carousel.closest('.exa-shop-hub__carousel-wrap');
        const previous = wrap?.querySelector('[data-carousel-previous]');
        const next = wrap?.querySelector('[data-carousel-next]');

        const getStep = () => {
          const firstCard = carousel.querySelector('.exa-shop-hub__product-card');
          if (!firstCard) return carousel.clientWidth * .8;
          const gap = Number.parseFloat(getComputedStyle(carousel).columnGap) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        };

        const updateControls = () => {
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (previous) previous.disabled = carousel.scrollLeft <= 18;
          if (next) next.disabled = carousel.scrollLeft >= maxScroll - 18;
        };

        previous?.addEventListener('click', () => carousel.scrollBy({ left: -getStep(), behavior: 'smooth' }));
        next?.addEventListener('click', () => carousel.scrollBy({ left: getStep(), behavior: 'smooth' }));
        carousel.addEventListener('scroll', updateControls, { passive: true });
        new ResizeObserver(updateControls).observe(carousel);
        requestAnimationFrame(updateControls);
      });

      root.querySelectorAll('[data-stamp-open]').forEach((button) => {
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (!dialog) return;

        const closeDialog = () => {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        };

        button.addEventListener('click', () => {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
        dialog.querySelector('[data-stamp-close]')?.addEventListener('click', closeDialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });
      });

      const status = root.querySelector('[data-share-status]');
      let statusTimer;
      const announce = (message) => {
        if (!status) return;
        status.textContent = message;
        status.classList.add('is-visible');
        window.clearTimeout(statusTimer);
        statusTimer = window.setTimeout(() => status.classList.remove('is-visible'), 2400);
      };

      root.querySelectorAll('.exa-shop-hub__share').forEach((button) => {
        button.addEventListener('click', async () => {
          const url = button.dataset.shareUrl || window.location.href;
          const title = button.dataset.shareTitle || document.title;

          try {
            if (navigator.share) await navigator.share({ title, url });
            else {
              await navigator.clipboard.writeText(url);
              announce(root.dataset.shareCopied);
            }
          } catch (error) {
            if (error.name !== 'AbortError') announce(root.dataset.shareFailed);
          }
        });
      });
    };

    document.querySelectorAll('[data-exa-shop-hub]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-exa-shop-hub]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-comercial"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('commercial-showcase')) {

    customElements.define(
      'commercial-showcase',
      class extends HTMLElement {

        connectedCallback() {

          this.viewport =
            this.querySelector(
              '[data-vc-viewport]'
            );

          this.track =
            this.querySelector(
              '[data-vc-track]'
            );

          this.controls =
            this.querySelector(
              '[data-vc-controls]'
            );

          this.previousButton =
            this.querySelector(
              '[data-vc-previous]'
            );

          this.nextButton =
            this.querySelector(
              '[data-vc-next]'
            );

          this.progress =
            this.querySelector(
              '[data-vc-progress]'
            );

          this.motionQuery =
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            );

          this.strength =
            Math.min(
              18,
              Math.max(
                0,
                Number(
                  this.dataset.strength
                ) || 0
              )
            );

          this.visible = false;

          this.viewportFrame = null;
          this.parallaxFrame = null;
          this.parallaxTimer = null;

          if (
            !this.viewport ||
            !this.track
          ) {
            return;
          }

          this.onViewportScroll =
            this.handleViewportScroll.bind(this);

          this.onWindowScroll =
            this.scheduleParallaxUpdate.bind(this);

          this.onResize =
            this.scheduleAll.bind(this);

          this.onPrevious =
            () => this.move(-1);

          this.onNext =
            () => this.move(1);

          this.onCardClick =
            this.emitCardClick.bind(this);

          /*
           * Scroll horizontal:
           * atualiza apenas UI leve durante o gesto.
           *
           * O parallax fica fora do loop contínuo,
           * evitando trabalho desnecessário durante
           * arrasto/momentum.
           */
          this.viewport.addEventListener(
            'scroll',
            this.onViewportScroll,
            {
              passive: true
            }
          );

          /*
           * Scroll vertical da página:
           * mantém o contramovimento do background.
           */
          window.addEventListener(
            'scroll',
            this.onWindowScroll,
            {
              passive: true
            }
          );

          window.addEventListener(
            'resize',
            this.onResize,
            {
              passive: true
            }
          );

          this.previousButton?.addEventListener(
            'click',
            this.onPrevious
          );

          this.nextButton?.addEventListener(
            'click',
            this.onNext
          );

          this.addEventListener(
            'click',
            this.onCardClick
          );

          this.observer =
            new IntersectionObserver(
              (entries) => {

                this.visible =
                  entries[0]?.isIntersecting ||
                  false;

                if (
                  this.visible
                ) {
                  this.scheduleAll();
                }

              },
              {
                rootMargin:
                  '120px 0px'
              }
            );

          this.observer.observe(this);

          this.scheduleAll();
        }

        disconnectedCallback() {

          this.viewport?.removeEventListener(
            'scroll',
            this.onViewportScroll
          );

          window.removeEventListener(
            'scroll',
            this.onWindowScroll
          );

          window.removeEventListener(
            'resize',
            this.onResize
          );

          this.previousButton?.removeEventListener(
            'click',
            this.onPrevious
          );

          this.nextButton?.removeEventListener(
            'click',
            this.onNext
          );

          this.removeEventListener(
            'click',
            this.onCardClick
          );

          this.observer?.disconnect();

          if (
            this.viewportFrame
          ) {
            cancelAnimationFrame(
              this.viewportFrame
            );
          }

          if (
            this.parallaxFrame
          ) {
            cancelAnimationFrame(
              this.parallaxFrame
            );
          }

          if (
            this.parallaxTimer
          ) {
            clearTimeout(
              this.parallaxTimer
            );
          }
        }

        move(direction) {

          const amount =
            Math.max(
              280,
              this.viewport.clientWidth *
                0.72
            );

          this.viewport.scrollBy({
            left:
              amount *
              direction,

            behavior:
              this.motionQuery.matches
                ? 'auto'
                : 'smooth'
          });
        }

        /*
         * Durante o gesto horizontal:
         * atualiza somente controles e progresso.
         */
        handleViewportScroll() {

          this.scheduleViewportUpdate();

          /*
           * Atualiza o parallax apenas após
           * o movimento horizontal desacelerar.
           */
          if (
            this.parallaxTimer
          ) {
            clearTimeout(
              this.parallaxTimer
            );
          }

          this.parallaxTimer =
            setTimeout(
              () => {

                this.parallaxTimer = null;

                this.scheduleParallaxUpdate();

              },
              140
            );
        }

        scheduleAll() {
          this.scheduleViewportUpdate();
          this.scheduleParallaxUpdate();
        }

        scheduleViewportUpdate() {

          if (
            this.viewportFrame
          ) {
            return;
          }

          this.viewportFrame =
            requestAnimationFrame(
              () => {

                this.viewportFrame = null;

                this.updateViewport();

              }
            );
        }

        scheduleParallaxUpdate() {

          if (
            this.parallaxFrame
          ) {
            return;
          }

          this.parallaxFrame =
            requestAnimationFrame(
              () => {

                this.parallaxFrame = null;

                this.updateParallax();

              }
            );
        }

        /*
         * Trabalho mínimo necessário durante
         * o scroll horizontal.
         */
        updateViewport() {

          const maxScroll =
            Math.max(
              0,
              this.viewport.scrollWidth -
                this.viewport.clientWidth
            );

          const progress =
            maxScroll > 0
              ? this.viewport.scrollLeft /
                maxScroll
              : 0;

          const hasOverflow =
            maxScroll > 2;

          if (
            this.controls
          ) {
            this.controls.hidden =
              !hasOverflow;
          }

          if (
            this.previousButton
          ) {
            this.previousButton.disabled =
              !hasOverflow ||
              this.viewport.scrollLeft <= 2;
          }

          if (
            this.nextButton
          ) {
            this.nextButton.disabled =
              !hasOverflow ||
              this.viewport.scrollLeft >=
                maxScroll - 2;
          }

          if (
            this.progress
          ) {

            const scale =
              hasOverflow
                ? Math.max(
                    .08,
                    progress
                  )
                : 1;

            this.progress.style.transform =
              `scaleX(${scale})`;
          }
        }

        /*
         * Parallax separado do scroll horizontal.
         *
         * Mantém o comportamento visual,
         * mas não disputa frames com o gesto.
         */
        updateParallax() {

          if (
            !this.visible ||
            this.motionQuery.matches ||
            this.strength === 0
          ) {

            this.style.setProperty(
              '--vc-bg-x',
              '0px'
            );

            this.style.setProperty(
              '--vc-bg-y',
              '0px'
            );

            return;
          }

          const maxScroll =
            Math.max(
              0,
              this.viewport.scrollWidth -
                this.viewport.clientWidth
            );

          const horizontalProgress =
            maxScroll > 0
              ? this.viewport.scrollLeft /
                maxScroll
              : 0;

          const rect =
            this.getBoundingClientRect();

          const verticalProgress =
            (
              window.innerHeight -
              rect.top
            ) /
            (
              window.innerHeight +
              rect.height
            );

          const x =
            (
              .5 -
              horizontalProgress
            ) *
            this.strength *
            2;

          const y =
            (
              .5 -
              verticalProgress
            ) *
            this.strength *
            2;

          this.style.setProperty(
            '--vc-bg-x',
            `${x.toFixed(2)}px`
          );

          this.style.setProperty(
            '--vc-bg-y',
            `${y.toFixed(2)}px`
          );
        }

        emitCardClick(event) {

          const link =
            event.target.closest(
              '[data-vc-card] a'
            );

          if (
            !link
          ) {
            return;
          }

          const card =
            link.closest(
              '[data-vc-card]'
            );

          this.dispatchEvent(
            new CustomEvent(
              'exallaxe:vitrine-card-click',
              {
                bubbles: true,

                detail: {

                  context:
                    this.dataset.context,

                  showcase:
                    this.dataset.showcase,

                  productId:
                    card.dataset.productId,

                  productHandle:
                    card.dataset.productHandle,

                  position:
                    Number(
                      card.dataset.position
                    )
                }
              }
            )
          );
        }

      }
    );
  }

  /*
   * CARREGAMENTO EM LOTES
   *
   * Cada <vc-deferred> se registra no seu lote.
   * Quando qualquer marcador do lote chega a 1,5 tela
   * de distância, o lote inteiro é buscado pela
   * Section Rendering API (até 5 sections por requisição)
   * e cada marcador é trocado pela vitrine completa.
   *
   * Links internos (#oferta, #rot-cashflow...) que apontam
   * para depois de um lote pendente carregam esse lote
   * antes de reposicionar a página.
   */
  if (!window.ExaVcDeferred) {

    window.ExaVcDeferred = (() => {

      const SECTIONS_PER_REQUEST = 5;

      const slotsByBatch = new Map();
      const loadingByBatch = new Map();

      let observer = null;

      const getObserver = () => {

        if (!observer) {
          observer =
            new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    load(entry.target.dataset.batch);
                  }
                });
              },
              {
                rootMargin: '150% 0px'
              }
            );
        }

        return observer;
      };

      const register = (slot) => {

        const batch = slot.dataset.batch;

        if (!slotsByBatch.has(batch)) {
          slotsByBatch.set(batch, new Set());
        }

        slotsByBatch.get(batch).add(slot);

        if (loadingByBatch.has(batch)) {
          return;
        }

        getObserver().observe(slot);
      };

      const sectionsUrl = (ids) => {

        const url = new URL(window.location.href);

        url.hash = '';
        url.searchParams.set('sections', ids.join(','));

        return url.toString();
      };

      const fetchSections = (ids) =>
        fetch(
          sectionsUrl(ids),
          {
            credentials: 'same-origin'
          }
        ).then((response) => {

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          return response.json();
        });

      const swap = (slot, html) => {

        if (!html || !slot.isConnected) {
          return false;
        }

        const template = document.createElement('template');
        template.innerHTML = html;

        const wrapper =
          template.content.querySelector('.shopify-section') ||
          template.content.firstElementChild;

        if (!wrapper || !wrapper.querySelector('.vc')) {
          return false;
        }

        observer?.unobserve(slot);
        slot.replaceWith(...wrapper.childNodes);

        return true;
      };

      const load = (batch) => {

        if (loadingByBatch.has(batch)) {
          return loadingByBatch.get(batch);
        }

        const slots =
          [...(slotsByBatch.get(batch) || [])]
            .filter((slot) => slot.isConnected);

        const ids =
          slots.map((slot) => slot.dataset.sectionId);

        const chunks = [];

        for (let index = 0; index < ids.length; index += SECTIONS_PER_REQUEST) {
          chunks.push(ids.slice(index, index + SECTIONS_PER_REQUEST));
        }

        const promise =
          Promise.all(
            chunks.map((chunk) =>
              fetchSections(chunk)
                .catch(() => fetchSections(chunk))
                .catch(() => ({}))
            )
          ).then((results) => {

            const sections = Object.assign({}, ...results);

            slots.forEach((slot) => {
              observer?.unobserve(slot);

              if (!swap(slot, sections[slot.dataset.sectionId])) {
                slot.classList.add('vc--deferred-failed');
              }
            });

            document.dispatchEvent(
              new CustomEvent(
                'exallaxe:vitrines-loaded',
                {
                  detail: {
                    batch
                  }
                }
              )
            );
          });

        loadingByBatch.set(batch, promise);

        return promise;
      };

      const precedes = (slot, target) =>
        slot === target ||
        slot.contains(target) ||
        Boolean(
          slot.compareDocumentPosition(target) &
          Node.DOCUMENT_POSITION_FOLLOWING
        );

      const pendingBatchesBefore = (target) => {

        const batches = new Set();

        slotsByBatch.forEach((slots, batch) => {
          slots.forEach((slot) => {
            if (slot.isConnected && precedes(slot, target)) {
              batches.add(batch);
            }
          });
        });

        return [...batches];
      };

      const findTarget = (hash) => {

        if (!hash || hash.length < 2) {
          return null;
        }

        try {
          return document.getElementById(decodeURIComponent(hash.slice(1)));
        } catch (error) {
          return null;
        }
      };

      const settleOn = (hash) => {

        const target = findTarget(hash);

        if (!target) {
          return;
        }

        const batches = pendingBatchesBefore(target);

        if (!batches.length) {
          return;
        }

        target.scrollIntoView({ block: 'start' });

        Promise.all(batches.map(load)).then(() => {
          findTarget(hash)?.scrollIntoView({ block: 'start' });
        });
      };

      document.addEventListener('click', (event) => {

        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        const link = event.target.closest('a[href*="#"]');

        if (!link) {
          return;
        }

        const url = new URL(link.href, window.location.href);

        if (
          url.origin !== window.location.origin ||
          url.pathname !== window.location.pathname ||
          !url.hash
        ) {
          return;
        }

        const target = findTarget(url.hash);

        if (!target || !pendingBatchesBefore(target).length) {
          return;
        }

        event.preventDefault();
        history.pushState(null, '', url.hash);
        settleOn(url.hash);
      });

      const settleInitialHash = () => settleOn(window.location.hash);

      if (window.location.hash) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', settleInitialHash, { once: true });
        } else {
          settleInitialHash();
        }
      }

      return {
        register,
        load
      };

    })();

    if (!customElements.get('vc-deferred')) {
      customElements.define(
        'vc-deferred',
        class extends HTMLElement {
          connectedCallback() {
            window.ExaVcDeferred.register(this);
          }
        }
      );
    }
  }


  } catch(e) { console.error(e); }
})();
})();
